module.exports = __webpack_public_path__ + "static/img/background.80a471d.jpeg";